import { useState } from "react";
import { ArrowRight, Check, X } from "lucide-react";
import { MIGRATION } from "../../config/lumacofono";
import { buildTransferUrl, importTransfer, shouldOfferTransfer } from "../../lib/migration";

const newHost = new URL(MIGRATION.targetOrigin).hostname;
// Runs once at module load, before any component reads localStorage.
const importedAtLoad = importTransfer();

// Old domain: offer the transfer link. New domain: confirm a completed transfer.
export const TransferBanner = () => {
  const [imported, setImported] = useState(importedAtLoad);
  const [offer] = useState(shouldOfferTransfer);

  if (imported) {
    return (
      <div className="mb-5 rounded-[18px] bg-white border border-[#D0E4F3] px-4 py-3 flex items-center gap-3" data-testid="transfer-done-banner">
        <Check size={18} className="text-[#7433C1] shrink-0" />
        <p className="text-[14px] font-semibold flex-1">Progressi trasferiti: record e ultime partite sono di nuovo qui.</p>
        <button type="button" aria-label="Chiudi" onClick={() => setImported(false)} className="w-9 h-9 flex items-center justify-center" data-testid="transfer-done-close">
          <X size={16} />
        </button>
      </div>
    );
  }
  if (!offer) return null;
  return (
    <div className="mb-5 rounded-[18px] bg-white border border-[#D0E4F3] px-4 py-3" data-testid="transfer-offer-banner">
      <p className="text-[14px] font-semibold">Il gioco si sposta su {newHost}.</p>
      <a
        href={buildTransferUrl()}
        data-testid="transfer-offer-link"
        className="mt-2 inline-flex items-center gap-2 min-h-[44px] rounded-[12px] bg-[#7433C1] text-white text-sm font-semibold px-4"
      >
        Porta con te record e ultime partite <ArrowRight size={16} />
      </a>
    </div>
  );
};
